import { render, staticRenderFns } from "./RoutesTable.vue?vue&type=template&id=06c23084"
import script from "./RoutesTable.vue?vue&type=script&lang=js"
export * from "./RoutesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports